if (!customElements.get('urbansale-press-slider')) {
    customElements.define(
      'urbansale-press-slider',
      class PressSlider extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
          this.main = this.querySelector('.press-testimonials');
  
          this.mainSlider = this.main.querySelector('.swiper');
  
          const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
          mql.onchange = this.init.bind(this);
          this.init();
        }
  
        init() {
          this.initSlider();
        }
  
        initSlider() {
          const swiper = new Swiper(this.mainSlider, {
            slidesPerView: 3,
            grid: {
              rows: 2,
              fill: 'row',
            },
            spaceBetween: 30,
            navigation: {
              nextEl: this.main.querySelector('.swiper-button-next'),
              prevEl: this.main.querySelector('.swiper-button-prev'),
            },
            pagination: {
              el: this.main.querySelector('.swiper-pagination'),
              clickable: true,
            },
            breakpoints: {
              768: {
                slidesPerView: 3,
                grid: {
                  rows: 1,
                  fill: 'row',
                },
              },
              1280: {
                slidesPerView: 7,
                grid: {
                  rows: 1,
                  fill: 'row',
                },
              },
            },
            loop: false,
          });
        }
      }
    );
  }
  